import Vue from 'vue'
import VueRouter from 'vue-router' 
import access from '../plugins/access'
import store from '@/store'; 
import { JwtStorage } from '@/lib/JwtStorage';

Vue.use(access);
Vue.use(VueRouter)

function tokenExists() {
  return JwtStorage.exists();
}

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: {
      title: "Synergy - Communications Hub",
      access: { roles: ["CommhubGoogleUIUser", "Admin"] }
    },
  },
  {
    path: "/surveys",
    name: "Surveys",
    component: () => import("../views/Surveys.vue"),
    meta: {
      title: "Synergy - Communications Hub",
      access: { roles: ["CommhubGoogleUIUser", "Admin"] }
    },
  },
  {
    path: "/survey-form",
    name: "SurveyForm",
    component: () => import("../views/SurveyForm.vue"),
    meta: {
      title: "GStay Guest survey", 
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue"),
    meta: {
      title: "*** ADMIN PAGE ***", 
      access: { roles: ["Admin"] }
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      title: "Synergy - Communications Hub | Login"
    }
  },
  {
    path: "/reset",
    name: "LoginReset",
    component: () => import("../views/LoginReset.vue"),
    meta: {
      title: "Synergy - Communications Hub | Login"
    }
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("../views/Page404.vue"),
    meta: {
      title: "Synergy Global Housing | 404 - Page Not Found"
    }
  },
  {
    path: "/401",
    name: "Unauthorized",
    component: () =>
      import("../views/Page401.vue"),
    meta: {
      title: "Synergy - Communications Hub"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
}) 

// Global guard and route storage when not authenticated or authorized
const nonGuardedRouteNames = ["Login", "LoginReset", "TempLink", "Community", "Unauthorized", "NotFound", "SurveyForm"];
router.beforeEach(async (to, from, next) => {
  if (to.query.q && to.path === '/') {
    console.log('survey redirect');
    next({ name: "SurveyForm", query: to.query })
    return true;
  }
  // await asyncTimeout(300); 
  if (nonGuardedRouteNames.includes(to.name)) {
    console.log("Non guarded route selected")
    next();
    router.app.$store.dispatch("appInited");
    return true;
  }

  if (tokenExists()) {
    console.log("Token does not exist in store, but exists in ls. Trying to reapply...");
    await router.app.$store.dispatch('user/reapplyToken');
  }

  
  if (!router.app.$store.state.user.token) {
    console.log("Jwt expired. Login route selected")
    next({ name: "Login" });
    router.app.$store.dispatch("appInited");
    return true;
  }
  
  const hasAny = to.meta.access.roles.some(x => x === router.app.$store.state.user.role) ?? false;
  console.log(`User has ${hasAny ? '' : 'no '}claims to access page ${to.fullPath}`);
  if (hasAny) {
    // console.log(`User has claims. ${to.fullPath} route selected`);
    next(); 
    router.app.$store.dispatch("appInited");
    return true;
  }
  
  
  console.log(`No route selected. Fallback to Login route`);
  next({ name: "Unauthorized" });
  router.app.$store.dispatch("appInited");
});

export default router
